import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const ContainerEstadoTabela = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 200px;
`;

const ContainerCarregando = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #008080;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const MensagemEstado = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #666;
  margin: 0;
  text-align: center;
`;

const MensagemVazia = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #999;
  margin: 0;
  text-align: center;
`;

export const EstadoCarregando = () => (
  <ContainerEstadoTabela>
    <ContainerCarregando>
      <Spinner />
      <MensagemEstado>Carregando...</MensagemEstado>
    </ContainerCarregando>
  </ContainerEstadoTabela>
);

export const EstadoVazio = () => (
  <ContainerEstadoTabela>
    <MensagemVazia>Não há designações cadastradas</MensagemVazia>
  </ContainerEstadoTabela>
);
